<app-nav></app-nav>
<main>
  <div id="center">
    <div id="nick">beaend</div>
    <div id="logo"><img src="http://beaend.ru/beaend.svg"></div>
  </div>
</main>
